__webpack_require__.p = "https://www.digital-control.com/";